import React from "react";
import ContactUsBelow from "../../components/ContactUsBelow";
import Head from "../../components/Head";
import background from "../../images/services_background.png";
import Button from "../../components/Button";
import ThankYou from "../../components/ThankYou";
export default function RAFThankYou() {
  return <ThankYou />;
}
